import {initTrustbars} from "../../../default/global/js/trustbar";
import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {closeFilterBox, initFilter} from "../../../default/global/js/filter";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {triggerFavoritesBtns} from "../../../default/global/js/favorites";
import hoverintent from "../../../default/global/js/hoverintent";
import {initSlideshows} from "../../../ragaller_global/js/slideshow";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {stickyBox} from "../../../default/global/js/stickyBox.js";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "../../../default/global/js/mobilemenu";
import {excludeModal, triggerConfirmModalLink, triggerModal} from "../../../default/global/js/modal";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {initItemlistSlider} from "../../../default/global/js/itemListSlider";
import {initScrollbars} from "../../../default/global/js/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../default/global/js/customSelect";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {initSearchItems} from "../../../default/global/js/searchItems";
import {initItemlistToggle} from "../../../default/global/js/itemlistToggle";
import {initPriceListGraduated} from "../../../default/global/js/priceListGraduated";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initFlashmessages} from "../../../default/global/js/flashmessages";
import {initPasswordFields} from "../../../default/global/js/password";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {initInputBody} from "../../../default/global/js/inputfile";
import {initImageGallery, initScrollingImageGallery} from "../../../default/global/js/imageGallery";
import {initAjaxCollectionFilter} from "../../../default/global/js/ajaxCollectionFilter";
import {initDatepicker} from "../../../default/global/js/datepicker";
import {initHistorySlider} from "../../../default/global/js/history";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {initRangeslider} from "../../../default/global/js/rangeSlider";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {initFlyout} from "../../../default/global/js/flyoutMenu";
import {initHighlightEditors} from "../../../default/global/ts/highlightEditor";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";
import {initAjaxFormApi} from "../../../default/global/js/ajaxFormApi";
import {initCategorySlider} from "../../../ragaller_global/js/categorySlider";
import {toggleSearch} from "../../../default/global/js/search";
import {initInteractiveCursor} from "../../../ragaller_global/js/interactiveCursor";
import {initDynamicPlaceholders} from "../../../ragaller_global/js/dynaimcPlaceholders";
import {initBusinessTilesSlider} from "../../../ragaller_global/js/initBusinessTilesSlider";
import {showStickyContactContent} from "../../../ragaller_global/js/showStickyContactContent";
import {countUp} from "../../../default/global/js/countUp";
import {removeStyleTagsInElements} from "../../../ragaller_global/js/removeStyleTagsInElements";
import {triggerBasketBtns, triggerUpdateBasketView} from "../../../default/global/js/basket";
import {initQuantitySpinners} from "../../../default/global/js/quantitySpinner";
import {hideEnquiryWhenZero} from "../../../ragaller_global/js/hideEnquiryWhenZero";


window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('header');

    const headerSearchMobileToggle = document.querySelector('.headerSearchMobileToggle');
    const headerSearch = document.querySelector('.headerSearch');

    if(headerSearchMobileToggle && headerSearch){
        headerSearchMobileToggle.addEventListener('click', function(){
            const algoliaAutocomplete = document.getElementById("algolia-autocomplete");

            if (algoliaAutocomplete) {
                const algoliaAutocompleteTrigger = algoliaAutocomplete.querySelector(".algoliaAutocompleteTrigger");
                if(algoliaAutocompleteTrigger) {
                    algoliaAutocompleteTrigger.click();
                }
                return;
            }

            toggleSearch(headerSearchMobileToggle,headerSearch);
        });
    }

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        if (window.innerWidth < 1250) {
            const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

            buildMobileMenu(mobileMenu);

            mobileMenuToggle.addEventListener("click", function () {
                showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            });

            mobileMenuClose.addEventListener("click", function () {
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            });

            overlay.addEventListener("click", function () {
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
                for (let filterbox of document.querySelectorAll('.filterBox')) {
                    closeFilterBox(filterbox);
                }
            });
        } else {
            mobileMenuToggle.addEventListener("click", function () {
                for(const headerMain of document.querySelectorAll('.headerMain')){
                    headerMain.classList.toggle('showMainNavigation');
                }
            });

            for (const algoliaAutocomplete of document.querySelectorAll('.algoliaAutocomplete')){
                algoliaAutocomplete.addEventListener('click', function (event) {
                    for(const headerMain of document.querySelectorAll('.headerMain')){
                        headerMain.classList.remove('showMainNavigation');
                    }
                });
            }
        }
    }

    initTrustbars();

    initFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    focusInputGroups();

    trimInputValues();

    initInputBody();

    initPasswordFields();

    initPhoneCountryFields();

    if (window.innerWidth < 1024) {
        for (let parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }

    triggerModal();
    excludeModal();
    triggerConfirmModalLink();

    initToggleSlide();

    initFlashmessages();

    if (!IsTouchDevice) {
        for (let el of document.querySelectorAll('.itembox,.iconbarItem')) {
            hoverintent(el);
        }
    }
    for (let el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }

    initImageGallery();

    initSlideshows();

    initScrollbars();

    initSlidecontents();

    triggerBasketBtns();

    hideEnquiryWhenZero();

    initItemlistSlider(document.querySelectorAll('.itemboxList.swiper'),{
        breakpointItems: {
            xs: 1.7,
            sm: 3,
            md: 4,
            lg: 4,
            xlg: 5
        }
    });

    initCustomSelects();

    initQuantitySpinners();

    // Tooltip, when necessary
    // import {Tooltip} from "../../../default/global/js/tooltip-custom";

    //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //    return new Tooltip(tooltipTriggerEl);
    //});

    initSearchItems(document.querySelectorAll('.js-searchInput'));

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS!== "undefined") {
        if(GLOBALS.offsetTopJumpmarks){
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);

    for (let item of document.querySelectorAll(".js-openGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    for (let pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }
    lottieLoader();

    initItemlistToggle();

    initPriceListGraduated();

    initAjaxCollectionFilter();

    initAjaxFormApi();

    initDatepicker();

    initHistorySlider();

    initFlyout();

    initContentTabs();

    initScrollActivate();

    showStickyContactContent();

    removeStyleTagsInElements();

    for (let el of document.querySelectorAll("[data-count-up]")) {
        countUp(el);
    }

    initRangeslider(document,function (e){
        if(e.slider.closest(".js-customSelect")){
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"),e.value);
        }
    });

    initRecaptchaForms();

    initHighlightEditors();

    maxHeightContent();

    initCategorySlider();

    initInteractiveCursor();

    initBusinessTilesSlider();

    initScrollingImageGallery();

    initDynamicPlaceholders();

    window.main = {
        hideAllCustomSelect: function (){
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select){
            hideCustomSelect(select);
        }
    };

    triggerUpdateBasketView();

    for (const emptyFooterLink of document.querySelectorAll('.footerMainNavigation .navgroup > ul > li > a[href="#"]')) {
        emptyFooterLink.setAttribute('href', '');
    }
});
